import { render, staticRenderFns } from "./select-icon.vue?vue&type=template&id=82839f76&"
import script from "./select-icon.vue?vue&type=script&lang=js&"
export * from "./select-icon.vue?vue&type=script&lang=js&"
import style0 from "./select-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports